import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from "react-router-dom";
import { LoadingScreen } from "@/components/ui";
import { usePortalNavigationAccess } from "@/hooks/usePortalNavigationAccess";
export default function RequireProductAccess({ children }) {
    const location = useLocation();
    const { canAccessPath, defaultPage, isLoading } = usePortalNavigationAccess();
    if (isLoading) {
        return /*#__PURE__*/ _jsx(LoadingScreen, {});
    }
    if (!canAccessPath(location.pathname)) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: defaultPage,
            replace: true
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
